export default __webpack_public_path__ + "static/media/twitter.b4c4b9e4.svg";